import React from 'react';
import { Phone, Play, BarChart2, Target, Users } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const YouTubeLanding = () => {
  const videoTestimonials = [
    {
      thumbnail: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&h=450",
      title: "How We Ranked #1 for 'Raleigh Contractors'",
      views: "2.4K views"
    },
    {
      thumbnail: "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?auto=format&fit=crop&w=800&h=450",
      title: "Local SEO Success Story: 3x Lead Generation",
      views: "1.8K views"
    }
  ];

  const stats = [
    {
      icon: BarChart2,
      value: "300%",
      label: "Average Traffic Increase"
    },
    {
      icon: Target,
      value: "90",
      label: "Days to First Page"
    },
    {
      icon: Users,
      value: "500+",
      label: "Local Businesses Helped"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <div className="inline-block bg-blue-600 px-4 py-2 rounded-full mb-6">
              As Featured in Our Latest Video
            </div>

            <h1 className="text-5xl font-bold mb-6">
              Watch How We Help Local Businesses
              <span className="text-blue-400"> Dominate Google</span>
            </h1>

            <p className="text-xl text-gray-300 mb-4">
              Learn the exact strategies we use to rank businesses on Google's first page
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-400 font-bold mb-8 hover:text-blue-300">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>
          </div>

          <div className="relative aspect-video mb-16 rounded-2xl overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&h=675"
              alt="SEO Strategy Video"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <button className="bg-blue-600 hover:bg-blue-700 p-6 rounded-full">
                <Play className="h-12 w-12" />
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="bg-gray-800 p-6 rounded-xl text-center"
              >
                <stat.icon className="h-12 w-12 text-blue-400 mx-auto mb-4" />
                <div className="text-4xl font-bold text-white mb-2">{stat.value}</div>
                <p className="text-gray-400">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {videoTestimonials.map((video, index) => (
              <div 
                key={index}
                className="bg-gray-800 rounded-xl overflow-hidden"
              >
                <div className="relative aspect-video">
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <button className="bg-blue-600 hover:bg-blue-700 p-4 rounded-full">
                      <Play className="h-8 w-8" />
                    </button>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold mb-2">{video.title}</h3>
                  <p className="text-gray-400">{video.views}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gray-800 rounded-2xl shadow-xl p-8 max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-center mb-6">Get Your Free SEO Strategy</h2>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Business Name"
                className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-gray-900 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-gray-900 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-gray-900 text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <Button className="w-full text-lg py-4">
                Get Free Strategy
              </Button>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default YouTubeLanding;